import React, { FC, useEffect, useState } from 'react';
import LoadingButton from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import Image from '../image/Image';
import { ITranslate } from 'core/interface/translate';

interface buttonType extends ITranslate {
  title: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset' | undefined;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  disableLoading?: boolean;
  iconName?: string;
  tooltip?: string;
  tooltipPlacement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
}

const Button: FC<buttonType> = ({
  onClick,
  title,
  className,
  disabled,
  isLoading,
  disableLoading,
  type = 'button',
  iconName,
  tooltip,
  tooltipPlacement = 'top',
  t
}): JSX.Element => {
  // const [language, setLanguage] = useState<string>('');
  // const win = typeof window != 'undefined';
  // useEffect(() => {
  //   if (win) {
  //     const checkLanguage = () => {
  //       const userLanguage = window.location.pathname.split('/')[1];
  //       if (userLanguage !== '') {
  //         setLanguage(userLanguage);
  //       }
  //     };
  //     checkLanguage();
  //   }
  // }, [win]);

  const handleClick = () => {
    if (onClick) onClick();
  };

  const buttonElement = (
    <LoadingButton
      style={{ textTransform: 'none', opacity: disabled ? 0.5 : 1 }}
      className={className}
      type={type}
      onClick={handleClick}
      disabled={disabled || isLoading}
      startIcon={
        !disableLoading && isLoading ? (
          <CircularProgress size={20} color="inherit" />
        ) : null
      }
    >
      {iconName && <Image className="btn-icon" name={iconName} />}
      {t(title) || title}
    </LoadingButton>
  );

  // If tooltip is provided, wrap the button with Tooltip component
  if (tooltip) {
    return (
      <Tooltip title={t(tooltip) || tooltip} placement={tooltipPlacement} arrow>
        <span style={{ display: 'inline-block' }}>{buttonElement}</span>
      </Tooltip>
    );
  }

  return buttonElement;
};

export default Button;
